export var bakeAnalyticsMeta = function bakeAnalyticsMeta() {
  var userIdentify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = config || {},
      product = _ref.product;

  var _ref2 = userIdentify || {},
      _ref2$is_classroom = _ref2.is_classroom,
      isClassroom = _ref2$is_classroom === void 0 ? false : _ref2$is_classroom,
      _ref2$is_demo = _ref2.is_demo,
      isDemo = _ref2$is_demo === void 0 ? false : _ref2$is_demo,
      _ref2$is_late = _ref2.is_late,
      isLate = _ref2$is_late === void 0 ? false : _ref2$is_late,
      _ref2$is_teacher = _ref2.is_teacher,
      isTeacher = _ref2$is_teacher === void 0 ? false : _ref2$is_teacher,
      _ref2$student_classro = _ref2.student_classroom_id,
      studentClassroomId = _ref2$student_classro === void 0 ? null : _ref2$student_classro,
      _ref2$teacher_classro = _ref2.teacher_classroom_id,
      teacherClassroomId = _ref2$teacher_classro === void 0 ? null : _ref2$teacher_classro;

  return {
    class_data: {
      is_classroom: isClassroom,
      is_demo: isDemo,
      is_late: isLate,
      is_teacher: isTeacher,
      student_classroom_id: studentClassroomId,
      teacher_classroom_id: teacherClassroomId
    },
    product: product,
    user_data: {
      is_teacher: isTeacher
    }
  };
};
//# sourceMappingURL=cue-analytics.js.map